export default __webpack_public_path__ + "images/dc05e61736208e6765b4fc3d3e6b6904.svg";